<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines" :inline="true">
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="create_user_text" label="日期" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="addressee" label="关注量" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="phone" label="累计关注量" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="create_user_text" label="注册率" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="address" label="注册量" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="address" label="累计注册量" width="100"></el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip width="180">
                    <el-table-column prop="address" label="访问量" width="100"></el-table-column>
                    <el-table-column prop="address" label="购买率" width="100"></el-table-column>
                    <el-table-column prop="address" label="购买人次" width="100"></el-table-column>
                    <el-table-column prop="address" label="购买量" width="100"></el-table-column>
                    <el-table-column prop="address" label="消费额" width="100"></el-table-column>
                    <el-table-column prop="address" label="人均消费" width="100"></el-table-column>
                </el-table-column>
                <el-table-column prop="address" label="情趣用品" width="100">
                    <el-table-column prop="address" label="访问量" width="100"></el-table-column>
                    <el-table-column prop="address" label="购买率" width="100"></el-table-column>
                    <el-table-column prop="address" label="购买人次" width="100"></el-table-column>
                    <el-table-column prop="address" label="购买量" width="100"></el-table-column>
                    <el-table-column prop="address" label="消费额" width="100"></el-table-column>
                    <el-table-column prop="address" label="人均消费" width="100"></el-table-column>
                </el-table-column>
                <el-table-column prop="address" label="营养保健" width="100">
                    <el-table-column prop="address" label="访问量" width="100"></el-table-column>
                    <el-table-column prop="address" label="购买率" width="100"></el-table-column>
                    <el-table-column prop="address" label="购买人次" width="100"></el-table-column>
                    <el-table-column prop="address" label="购买量" width="100"></el-table-column>
                    <el-table-column prop="address" label="消费额" width="100"></el-table-column>
                    <el-table-column prop="address" label="人均消费" width="100"></el-table-column>
                </el-table-column>
                <el-table-column prop="address" label="性福学院" width="100">
                    <el-table-column prop="address" label="访问量" width="100"></el-table-column>
                    <el-table-column prop="address" label="购买率" width="100"></el-table-column>
                    <el-table-column prop="address" label="购买人次" width="100"></el-table-column>
                    <el-table-column prop="address" label="购买量" width="100"></el-table-column>
                    <el-table-column prop="address" label="消费额" width="100"></el-table-column>
                    <el-table-column prop="address" label="人均消费" width="100"></el-table-column>
                </el-table-column>
                <el-table-column prop="address" label="总访问量" width="100"></el-table-column>
                <el-table-column prop="address" label="总购买率" width="100"></el-table-column>
                <el-table-column prop="address" label="总购买人次" width="100"></el-table-column>
                <el-table-column prop="address" label="总购买量" width="100"></el-table-column>
                <el-table-column prop="address" label="总消费" width="100"></el-table-column>
                <el-table-column prop="address" label="人均消费" width="100"></el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">审核
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 170 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 170 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                // axios
                //     .post("/admin/DoctorQrcodeRecord/index", {
                //         page: that.currentPage,
                //         page_count: that.pagesize,
                //     }, {
                //         token: true
                //     })
                //     .then(response => {
                //         that.loading = false
                //         that.tableData = response.data.data.list
                //         that.count = response.data.data.totalCount
                //     })
                //     .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },


        },

    };
</script>


<style>

</style>